import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  Menu,
  Switch,
  Avatar,
  IconButton,
} from "@mui/material";
import { DeleteOutline, EditOutlined, Share } from "@mui/icons-material";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import IButtonModal from "../Modals/IButtonModal";

// Assuming all other necessary imports are here
import DeleteAlert from "../AlertBox/DeleteAlert";
import ApiAlert from "../AlertBox/ApiAlert";
import { IOSSwitchButton } from "../ReusableComponents/SwitchButtons";
import { columns, jobSharingMenu } from "../../constants/openingTab";
import { useDebounce } from "../../hooks/useDebounce";
import img_not_found from "../../assets/img_not_found.jpg";
import { roleModulePermissions } from "../../utils/roleInstance";
import {
  getQuestionPackage,
  deleteQuestionPackage,
  editQuestionPackageStatus,
  shareJobInCareerActionFn,
} from "../../Redux/QuestionPacakge/action";

const OpenningsTable = (props) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [alert, setAlert] = useState(false);
  const [alertContent, setalertcontent] = useState("");
  const [alertStatus, setAlertStatus] = useState(true);
  const [copyStatus, setCopyStatus] = useState(false);
  const [jobIdCopyStatus, setJobIdCopyStatus] = useState(0);
  const { debouncedValue } = useDebounce(props.search, 500);
  const [shareEnchorEl, setShareEnchorEl] = useState(null);
  const [sharingJobOpening, setSharingJobOpening] = useState(null);
  const [switchOpen, setSwitchOpen] = useState(false);
  const [switchInactive, setSwitchInactive] = useState(null);
  const [showImage, setShowImage] = useState("");
  const [anchorEl2, setAnchorEl2] = useState(null);

  const questionPackage = useSelector(
    (state) => state.questionPackageReducer.questionsPackage
  );
  const questionPackageLength = useSelector(
    (state) => state.questionPackageReducer.length
  );

  const [openingEditAction, setOpeningEditAction] = useState(false);
  const [openingDeleteAction, setOpeningDeleteAction] = useState(false);

  // --- All of your logic functions remain unchanged ---
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClickOpen = (data) => {
    if (data?.jobRole?.role === "Any Open Position") {
      setAlert(true);
      setAlertStatus(false);
      setalertcontent("You can't delete the 'Any Open Position' campaign.");
      return;
    }
    setOpen(true);
    setIdToDelete(data.openingId);
  };
  const handleClickOpenSwich = (data) => {
    setSwitchOpen(true);
    setSwitchInactive(data);
  };
  const switchHandleClose = () => {
    setSwitchOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const editCampaignStatus = (data) => {
    const id = data.openingId;
    const status = !data.openingStatus;
    dispatch(editQuestionPackageStatus(id, status))
      .then((res) => {
        if (res.payload.status === 200) {
          setAlert(true);
          setAlertStatus(res.payload.data.status);
          setalertcontent(res.payload.data.message);
        } else {
          setAlert(true);
          setAlertStatus(res.payload.response.data.status);
          setalertcontent(res.payload.response.data.message);
        }
        switchHandleClose();
        getOpeningData(page, rowsPerPage);
      })
      .catch((err) => console.log(err));
  };
  const openingsDataDelete = () => {
    dispatch(deleteQuestionPackage(idToDelete))
      .then((res) => {
        setAlert(true);
        setAlertStatus(res.payload.status);
        setalertcontent(res.payload.message);
        handleClose();
        getOpeningData(page, rowsPerPage);
      })
      .catch((err) => console.log(err));
  };
  const getOpeningData = (page, rowsPerPage) => {
    dispatch(getQuestionPackage(page + 1, rowsPerPage, debouncedValue));
  };
  useEffect(() => {
    setPage(0);
  }, [debouncedValue]);
  useEffect(() => {
    getOpeningData(page, rowsPerPage);
  }, [page, rowsPerPage, debouncedValue]);
  const AlerthandleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setAlert(false);
  };
  const handleCopyImage = (imageLink, jobId) => {
    if (!imageLink) return;
    navigator.clipboard.writeText(imageLink).then(() => {
      setCopyStatus(true);
      setJobIdCopyStatus(jobId);
      setTimeout(() => setCopyStatus(false), 2000);
    });
  };
  useEffect(() => {
    const checkOpeningAction = async () => {
      const roleData = { roleModule: "Openings" };
      const [editPermission, deletePermission] = await Promise.all([
        roleModulePermissions.checkUserRoles(roleData, "edit"),
        roleModulePermissions.checkUserRoles(roleData, "delete"),
      ]);
      setOpeningEditAction(editPermission);
      setOpeningDeleteAction(deletePermission);
    };
    checkOpeningAction();
  }, [page]);
  const onShareMenuClose = () => {
    setShareEnchorEl(null);
    setSharingJobOpening(null);
  };
  const onShareMenuOpen = (event, row) => {
    setSharingJobOpening(row);
    setShareEnchorEl(event.currentTarget);
  };
  const handleShareJobOnChange = (e) => {
    let { checked, name } = e.target;
    if (name === "Career Portal") {
      let data = {
        sharedCareerOpening: checked,
        openingId: sharingJobOpening.openingId,
      };
      dispatch(shareJobInCareerActionFn(data))
        .then((res) => {
          if (res.type === "SHARE_JOB_IN_CAREER_SUCCESS") {
            onShareMenuClose();
            setAlert(true);
            setAlertStatus(true);
            setalertcontent(res.payload.message);
            getOpeningData(page, rowsPerPage);
          }
        })
        .catch((err) => console.log("error", err));
    }
  };
  const safeQuestionPackage = (questionPackage || []).filter(Boolean);
  return (
    <>
      {alert && (
        <ApiAlert
          open={alert}
          snackbaronClose={AlerthandleClose}
          alertType={alertStatus ? "success" : "error"}
          Content={alertContent}
        />
      )}
      <Box sx={{ width: "100%", height: "calc(100vh - 270px)" }}>
        <Paper
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <TableContainer sx={{ flexGrow: 1, overflow: "auto" }}>
            <Table sx={{ minWidth: 1200 }}>
              <TableHead sx={{ position: "sticky", top: 0, zIndex: 2 }}>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      sx={{
                        minWidth: column.minWidth,
                        backgroundColor: "primary.main",
                        color: "secondary.main",
                        fontWeight: 600,
                        ...(column.id === "Action" && {
                          position: "",
                          right: 0,
                          zIndex: 3,
                        }),
                      }}
                    >
                      {column.id === "Action" &&
                      !(openingEditAction || openingDeleteAction)
                        ? ""
                        : column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {safeQuestionPackage.map((el, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      cursor: el?.openingStatus ? "pointer" : "not-allowed",
                      opacity: el?.openingStatus ? 1 : 0.6, // makes disabled els look dimmed
                      backgroundColor: (theme) =>
                        el?.openingStatus
                          ? theme.palette.background.paper // normal
                          : theme.palette.action.disabledBackground, // subtle grey for disabled
                      "&:hover": {
                        backgroundColor: (theme) =>
                          el?.openingStatus
                            ? theme.palette.action.hover
                            : theme.palette.action.disabledBackground, // prevent hover color on disabled
                      },
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <TableCell align="right">
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell align="left">{el?.recCompanyName}</TableCell>
                    <TableCell align="left">{el?.jobRoleTitle}</TableCell>
                    <TableCell align="center" sx={{ cursor: "pointer" }}>
                      <Tooltip title="click to view image" arrow>
                        <Box
                          component="img"
                          src={el?.jobRole?.image}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = img_not_found;
                          }}
                          onClick={(e) => {
                            setAnchorEl2(e.currentTarget);
                            setShowImage(el?.jobRole?.image);
                          }}
                          sx={{
                            width: 60,
                            height: 70,
                            objectFit: "cover",
                            borderRadius: 2,
                            border: "1px solid black",
                          }}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell align="left">
                      <Tooltip
                        title={el?.selectedQuestionList
                          ?.map((q) => q.Question)
                          .join(", ")}
                        arrow
                      >
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{ maxWidth: 200 }}
                        >
                          {el?.selectedQuestionList?.length > 0
                            ? `${el.selectedQuestionList[0].Question}... +${
                                el.selectedQuestionList.length - 1
                              } more`
                            : "No questions selected"}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        position: "",
                        right: 0,
                      }}
                    >
                      <Stack
                        direction="row"
                        justifyContent="center"
                        spacing={1}
                      >
                        <Tooltip
                          title={
                            copyStatus && el.openingId === jobIdCopyStatus
                              ? "Copied!"
                              : "Copy Image Link"
                          }
                          arrow
                        >
                          <span>
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleCopyImage(
                                  el?.jobRole?.image,
                                  el?.openingId
                                )
                              }
                              disabled={!el?.jobRole?.image}
                            >
                              {copyStatus &&
                              el.openingId === jobIdCopyStatus ? (
                                <FileDownloadDoneIcon
                                  fontSize="small"
                                  color="success"
                                />
                              ) : (
                                <ContentCopyRoundedIcon fontSize="small" />
                              )}
                            </IconButton>
                          </span>
                        </Tooltip>

                        {openingEditAction && (
                          <Tooltip title="Edit Opening" arrow>
                            <Link
                              to={`/selected_question/${
                                el?.jobRoleId
                              }/${el?.companyIds.join(",")}`}
                              style={{ color: "inherit" }}
                            >
                              <IconButton
                                size="small"
                                disabled={!el.openingStatus}
                                sx={{
                                  "&:hover": {
                                    color: "rgb(254, 154, 37)",
                                    cursor: "pointer",
                                  },
                                }}
                              >
                                <EditOutlined fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>
                        )}

                        {openingDeleteAction && (
                          <Tooltip title="Delete" arrow>
                            <span>
                              <IconButton
                                size="small"
                                onClick={() => handleClickOpen(el)}
                                disabled={!el.openingStatus}
                                sx={{ "&:hover": { color: "error.main" } }}
                              >
                                <DeleteOutline fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                        )}

                        {openingDeleteAction && (
                          <Tooltip
                            title={el.openingStatus ? "Deactivate" : "Activate"}
                            arrow
                          >
                            <Box sx={{ transform: "scale(0.7)" }}>
                              <IOSSwitchButton
                                checked={el.openingStatus}
                                onChange={() =>
                                  el.openingStatus
                                    ? handleClickOpenSwich(el)
                                    : editCampaignStatus(el)
                                }
                              />
                            </Box>
                          </Tooltip>
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={questionPackageLength || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ flexShrink: 0, borderTop: 1, borderColor: "divider" }}
          />
        </Paper>
      </Box>

      {/* ✅ Modals and Menus are now OUTSIDE the main layout container */}
      <DeleteAlert
        open={open}
        onClose={handleClose}
        handleDelete={openingsDataDelete}
        rightButton="Delete"
        header="Confirm Deletion"
        message="Are you sure you want to delete this opening?"
      />
      <DeleteAlert
        open={switchOpen}
        onClose={switchHandleClose}
        handleDelete={() => editCampaignStatus(switchInactive)}
        rightButton="Deactivate"
        header="Deactivate Opening"
        message="Are you sure you want to deactivate this opening?"
      />
      <ShareMenu
        enchorEl={shareEnchorEl}
        onClose={onShareMenuClose}
        onChange={handleShareJobOnChange}
        openedRow={sharingJobOpening}
      />
      <IButtonModal
        type="img"
        element={showImage}
        anchorEl={anchorEl2}
        setAnchorEl={setAnchorEl2}
      />
    </>
  );
};

// These helper components remain unchanged
function ShareMenu({ enchorEl, onClose, onChange, openedRow }) {
  // ... (no changes needed here)
  return (
    <Menu
      open={Boolean(enchorEl)}
      anchorEl={enchorEl}
      onClose={onClose}
      transformOrigin={{ horizontal: "center", vertical: "top" }}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      MenuListProps={{ onMouseLeave: onClose }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "& .MuiAvatar-root": { width: 32, height: 32, ml: -0.5, mr: 1 },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: "calc(50% - 5px)",
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
    >
      <Box
        sx={{
          width: "200px",
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography textAlign={"center"} variant="subtitle2">
          Share On
        </Typography>
        {jobSharingMenu.map((elem) => (
          <Box
            key={elem.title}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <LogoTextBox text={elem.title} logo={elem.logo} />
            <Switch
              name={elem.title}
              disabled={elem.disabled}
              onChange={onChange}
              checked={
                elem.title === "Career Portal" &&
                openedRow?.sharedCareerOpening === true
              }
            />
          </Box>
        ))}
      </Box>
    </Menu>
  );
}

function LogoTextBox({ text, logo }) {
  // ... (no changes needed here)
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Avatar
        variant="rounded"
        src={logo}
        alt={text}
        sx={{ width: 24, height: 24 }}
      />
      <Typography variant="body2">{text}</Typography>
    </Box>
  );
}

export default OpenningsTable;
